var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sleepDruation"},[_c('div',{staticClass:"eacharts"},[_c('echarts',{attrs:{"chart-id":'sleepDruation',"chart-option":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }